import { DatabasesDisplayPlacePageData, TablesDisplayPlacePageData } from '@tableau/catalog-ui-temp';
import React from 'react';

import { ActionsMenu } from '~src/spacesPlatform/components/ActionsMenu/ActionsMenu';

import { mapGraphTypeToContentInfoForActions } from '../../models/mappers/DatabaseAndTableMapper';

export function renderDatabasesActionMenu(database: DatabasesDisplayPlacePageData): JSX.Element {
  return <ActionsMenu targetItems={[mapGraphTypeToContentInfoForActions(database)]} useIcon={true} />;
}

export function renderTablesActionMenu(table: TablesDisplayPlacePageData): JSX.Element {
  return <ActionsMenu targetItems={[mapGraphTypeToContentInfoForActions(table)]} useIcon={true} />;
}
